import React from "react";

import Button from "../Button";
import LabelTextInput from "../LabelTextInput";
import ClipLoader from "react-spinners/ClipLoader";

import classes from "./RequestDemoForm.module.css";

import useForm, { SUBMITTED, SUBMITTING, FAILED } from "../../hooks/useForm";
import { CONTACT_US } from "../../api";

const initialFormState = {
  customer_name: "",
  company_name: "",
  email_address: "",
  message: "",
  phone: "",
};

const RequestDemoForm = ({ onSubmit }) => {
  const formOptions = {
    uri: CONTACT_US,
    additionalFormBody: {
      request_phone_callback: false,
      locale: "en-us",
      should_subscribe: true,
    },
    optionalStates: ["phone"],
  };

  const { formFields, formStatus, handleSubmit, disabled } = useForm(
    initialFormState,
    formOptions,
    onSubmit
  );

  return (
    // TODO: merge component with Callback
    <form className={classes.form} onSubmit={handleSubmit}>
      {formStatus !== SUBMITTED && (
        <div>
          <p className={classes.message}>
            Unlock the power of transactional e-mail data to discover new,
            actionable insights.
          </p>
          <LabelTextInput
            label="Name"
            id="name"
            value={formFields.customer_name.value}
            onChange={(event) =>
              formFields.customer_name.onChange(event.target.value)
            }
          />
          <LabelTextInput
            label="Company Name"
            id="companyName"
            value={formFields.company_name.value}
            onChange={(event) =>
              formFields.company_name.onChange(event.target.value)
            }
          />
          <LabelTextInput
            label="Email"
            id="email"
            type="email"
            name="email"
            value={formFields.email_address.value}
            onChange={(event) =>
              formFields.email_address.onChange(event.target.value)
            }
          />
          <LabelTextInput
            label="Phone Number"
            id="phone"
            value={formFields.phone.value}
            optional
            onChange={(event) => formFields.phone.onChange(event.target.value)}
          />
          <LabelTextInput
            className={classes.textarea}
            label="Message"
            as="textarea"
            rows={3}
            id="message"
            value={formFields.message.value}
            onChange={(event) =>
              formFields.message.onChange(event.target.value)
            }
          />
          <p className={classes.message}>
            By submitting the form, you agree to the{" "}
            <a href="https://measurable.ai/en-US/privacyPolicy">
              privacy policy
            </a>
            ,{" "}
            <a href="https://measurable.ai/en-US/termsOfUse">
              terms of service
            </a>{" "}
            and to receive updates about Measurable AI
          </p>
        </div>
      )}
      <div className={classes.footer}>
        {formStatus === SUBMITTED ? (
          <>
            <p className={classes.submittedMessage}>
              Thanks for getting in touch! You’ll be hearing from us soon.
            </p>
            <p className={classes.submittedMessage}>
              In the meantime, read our latest insights here.
            </p>
          </>
        ) : formStatus === FAILED ? (
          <p
            className={[classes.submittedMessage, classes.errorMessage].join(
              " "
            )}
          >
            We failed to send your request. Please try again later!
          </p>
        ) : null}

        {formStatus === SUBMITTED ? (
          <a
            href="https://measurable.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Check out Measurable AI's website
          </a>
        ) : (
          <Button
            type="submit"
            className={classes.submitButton}
            disabled={disabled}
          >
            {formStatus === SUBMITTING ? (
              <ClipLoader size={14} color={"#221852"} />
            ) : (
              <span>Submit</span>
            )}
          </Button>
        )}
      </div>
    </form>
  );
};

export default RequestDemoForm;
